import { styled } from "../imports";
import { prop, spaceProp } from "../utils";
import Box from "./Box";
var canUseWidthOrHeight = function canUseWidthOrHeight(val) {
  return val > 0 || typeof val === "string" && val[0] !== "-";
};
var spaceX = function spaceX(val, rawVal) {
  if (rawVal === 0) return "min-width:0;width:0;margin-left:0";
  return canUseWidthOrHeight(rawVal) ? "min-width:" + val + ";width:" + val : "margin-left:" + val;
};
var spaceY = function spaceY(val, rawVal) {
  if (rawVal === 0) return "min-height:0;height:0;margin-top:0";
  return canUseWidthOrHeight(rawVal) ? "min-height:" + val + ";height:" + val : "margin-top:" + val;
};
var space = function space(val, rawVal, p) {
  if (p.x === true && !p.y) return spaceX(val, rawVal);
  if (!p.x && p.y === true) return spaceY(val, rawVal);
  if (!p.x && !p.y) {
    if (rawVal === 0) {
      // if it equals 0 than we want to reset
      // but we don't know which prop was set
      // so we have to reset them all...
      return "min-width:0;width:0;min-height:0;height:0;margin-top:0;margin-left:0";
    }
    return canUseWidthOrHeight(rawVal) ? "min-width:" + val + ";width:" + val + ";min-height:" + val + ";height:" + val : "margin-top:" + val + ";margin-left:" + val;
  }
  return "";
};
var Space = /*#__PURE__*/styled(Box, {
  label: "Space",
  target: "css-13ys2ql0"
})(prop("inline", "display:inline-block;"), ";", spaceProp(space), ";", prop("x", spaceX), ";", prop("y", spaceY), ";");
Space.displayName = "Space";
export default Space;